import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { image } from 'd3';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    standalone: false
})
export class NavBarComponent {
  @Input() currentUrl: string = '';

  constructor(private readonly router: Router){
  }
  
  bottomNav: NavigationModel[] = [
    { 
      name: 'Dashboard', 
      route: '/dashboard', 
      icon : 'pi pi-th-large' 
    },
    { 
      name: 'Main KPI',
      route :'/main-kpi',
      icon: 'pi pi-book' 
    },
    { 
      name: 'Gantt',
       route: '/gantt',
        icon: 'pi pi-chart-bar' 
      },
    { 
      name: 'Map',
       route: '/map',
        icon: 'pi pi-map' 
      },
    { 
      name: 'Reports',
       route: '/reports',
        icon: 'pi pi-file-check' 
      },
    { 
      name: 'Lookup',
       route: '/lookup', 
       icon: 'pi pi-search'
       },
    { 
      name: 'User Preferences',
       route: '/user-preferences',
        icon: 'pi pi-cog' 
      }
  ];


  navigateTo(option:NavigationModel) {
    this.router.navigate([`${option.route}`])
  }
 }

interface NavigationModel {name: string, route:string, icon:string}